<template>
  <div><search></search></div>
</template>
<script>
import Search from "@/components/Search";
export default {
  name: "Clinic",
  components: {
      Search
  }
};
</script>
